import React from 'react';
import PropTypes from 'prop-types';
import _isNil from 'lodash/isNil';
import _isEmpty from 'lodash/isEmpty';
import _debounce from 'lodash/debounce';
// Core components
import MenuButton from 'components/core/MenuButton';
// Custom
import { menuItemsShape } from 'constants/PropTypesShapes';
import { RefreshTextButton } from 'components/buttons/TextButtons';
import LoadingDisplayer from 'components/misc/LoadingDisplayer';

class SubViewTemplate extends React.Component {
  constructor(props) {
    super(props);

    // Desynchro reload management
    this.performRefreshAfterDesynchro = _debounce(this.doRefresh, 2000);
  }

  componentDidUpdate() {
    const { desynchronized } = this.props;

    // Desynchro catching
    if (desynchronized) {
      // Debounce a refresh
      this.performRefreshAfterDesynchro();
    } else {
      // Cancel current debounce, if any
      this.performRefreshAfterDesynchro.cancel();
    }
  }

  componentWillUnmount() {
    // Cancel current debounce, if any
    this.performRefreshAfterDesynchro.cancel();
  }

  // Private
  doRefresh() {
    const { onRefresh } = this.props;
    if (!_isNil(onRefresh)) {
      onRefresh();
    }
  }

  render() {
    const {
      title, actionButtons, extraActionButtons, menuItems, additionalContent, loading, children, onRefresh,
    } = this.props;

    // All buttons
    const buttons = _isNil(actionButtons) ? [] : [...actionButtons];
    if (!_isNil(onRefresh)) {
      buttons.push(<RefreshTextButton key="refresh" primary onClick={onRefresh} />);
    }

    return (
      <React.Fragment>
        {title && (
          <div className="box box-default m-0">
            <div className="box-header c-list-header box-title py-2 d-flex align-items-center">
              <div style={{ flex: '1 1 auto' }} className="d-flex align-items-center">
                {title}
              </div>
              <div style={{ flex: '0 0 auto' }} className="d-flex align-items-end align-items-md-center flex-column flex-md-row left-spaced-buttons">
                { buttons }
                {!_isEmpty(menuItems) && (
                  <div className="c-list-header-menu">
                    <MenuButton items={menuItems} />
                  </div>
                )}
                {!_isEmpty(extraActionButtons) && (
                  <div className="c-list-header-extra">
                    { extraActionButtons }
                  </div>
                )}
              </div>
            </div>
          </div>
        )}
        {additionalContent}
        <div className="px-0 w-100">
          <LoadingDisplayer loading={loading}>
            {children}
          </LoadingDisplayer>
        </div>
      </React.Fragment>
    );
  }
}

SubViewTemplate.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  actionButtons: PropTypes.arrayOf(PropTypes.element),
  extraActionButtons: PropTypes.arrayOf(PropTypes.element),
  menuItems: menuItemsShape,
  additionalContent: PropTypes.element,
  loading: PropTypes.bool,
  desynchronized: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  onRefresh: PropTypes.func,
};

SubViewTemplate.defaultProps = {
  title: null,
  actionButtons: null,
  extraActionButtons: null,
  menuItems: null,
  additionalContent: null,
  loading: false,
  desynchronized: false,
  onRefresh: null,
};

module.exports = SubViewTemplate;



// WEBPACK FOOTER //
// ./components/templates/SubViewTemplate.js